<template>
  <q-layout view="hHh lpR fFf">
    <!-- HEADER -->
    <q-header elevated class="bg-primary text-white">
      <q-toolbar>
        <q-btn flat round icon="menu" @click="toggleLeftDrawer" />

        <q-toolbar-title>
          <img src="@/assets/logo.png" alt="iMenuNexus" class="logo" />
        </q-toolbar-title>

        <q-btn flat round icon="home" :label="$t('common.home')" @click="navigateHome" />

        <!-- Language Selector -->
        <div class="q-mx-sm">
          <LanguageSelector />
        </div>

        <q-btn v-if="!authStore.isAuthenticated" flat :label="$t('auth.login')" @click="navigateLogin" />
        <q-btn-dropdown v-else flat :label="$t('auth.account')">
          <q-list>
            <q-item clickable v-close-popup @click="handleLogout">
              <q-item-section>{{ $t('auth.logout') }}</q-item-section>
            </q-item>
          </q-list>
        </q-btn-dropdown>
      </q-toolbar>
    </q-header>

    <!-- SIDEBAR (DRAWER) -->
    <q-drawer v-model="leftDrawerOpen" bordered>
      <q-list>
        <q-item v-for="item in userMenuItems" :key="item.label" clickable :to="item.to">
          <q-item-section avatar>
            <q-icon :name="item.icon" />
          </q-item-section>
          <q-item-section>{{ $t(item.label) }}</q-item-section>
        </q-item>
      </q-list>
    </q-drawer>

    <!-- MAIN CONTENT -->
    <q-page-container>
      <router-view />
    </q-page-container>
  </q-layout>
</template>

<script setup>
import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import LanguageSelector from "@/components/LanguageSelector.vue";
import { useQuasar } from "quasar";
import { useI18n } from "vue-i18n";

// Store & Router
const authStore = useAuthStore();
const router = useRouter();
const $q = useQuasar();
const { t } = useI18n();

// Reactive state
const leftDrawerOpen = ref(false);

// Toggle sidebar
const toggleLeftDrawer = () => {
  leftDrawerOpen.value = !leftDrawerOpen.value;
};

// Navigation functions
const navigateHome = () => router.push({ name: "home" });
const navigateLogin = () => router.push({ name: "login" });

// Logout function
const handleLogout = async () => {
  try {
    await authStore.logout();
    router.push({ name: "home" });
  } catch (error) {
    console.error("Logout error:", error);
    $q.notify({ type: "negative", message: t("auth.logoutError") });
  }
};

// Sidebar menu items (dynamic based on roles)
const userMenuItems = computed(() => {
  const items = [
    { label: "dashboard.dashboard", icon: "dashboard", to: "/dashboard" },
    { label: "billing.billingManagement", icon: "payments", to: "/billing-management" },
  ];

  if (authStore.user?.roles?.includes("admin")) {
    items.push({ label: "admin.adminPanel", icon: "admin_panel_settings", to: "/admin-dashboard" });
  }

  return items;
});
</script>

<style scoped>
.logo {
  height: 40px;
  margin-right: 10px;
  vertical-align: middle;
}

.q-toolbar .q-btn {
  margin-left: 5px;
  margin-right: 5px;
}

.q-drawer {
  background-color: #f9f9f9;
  color: #333;
}

.q-drawer .q-item {
  margin: 0.5rem 0;
}

.q-drawer .q-item:hover {
  background-color: #f0f0f0;
}
</style>
